import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Stack, AppBar, Toolbar, IconButton } from '@mui/material';
// utils
import { bgBlur } from '../../../utils/cssStyles';
// components
import Iconify from '../../../components/iconify';
//
import AccountPopover from './AccountPopover';
import NotificationsPopover from './NotificationsPopover';

// ----------------------------------------------------------------------

const NAV_WIDTH = 280;

const HEADER_MOBILE = 64;

const HEADER_DESKTOP = 92;

const StyledRoot = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== 'isDesktopNavOpen',
})(({ theme, isDesktopNavOpen }) => ({
  ...bgBlur({ color: theme.palette.background.default }),
  boxShadow: 'none',
  [theme.breakpoints.up('lg')]: {
    width: isDesktopNavOpen ? `calc(100% - ${NAV_WIDTH + 1}px)` : '100%',
  },
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: HEADER_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: HEADER_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

// ----------------------------------------------------------------------

Header.propTypes = {
  onOpenNav: PropTypes.func,
  onToggleDesktopNav: PropTypes.func,
  isDesktopNavOpen: PropTypes.bool,
};

export default function Header({ onOpenNav, onToggleDesktopNav, isDesktopNavOpen }) {
  return (
    <StyledRoot isDesktopNavOpen={isDesktopNavOpen}>
      <StyledToolbar>
        <IconButton
          onClick={onOpenNav}
          sx={{
            mr: 1,
            color: 'text.primary',
            display: { lg: 'none' },
          }}
        >
          <Iconify icon="eva:menu-2-fill" />
        </IconButton>

        <IconButton
          onClick={onToggleDesktopNav}
          sx={{
            mr: 1,
            color: 'text.primary',
            display: { xs: 'none', lg: 'inline-flex' },
          }}
        >
          <Iconify icon={isDesktopNavOpen ? 'eva:arrow-ios-back-fill' : 'eva:arrow-ios-forward-fill'} />
        </IconButton>

        <Box sx={{ flexGrow: 1 }} />

        <Stack
          direction="row"
          alignItems="center"
          spacing={{
            xs: 0.5,
            sm: 1,
          }}
        >
          <NotificationsPopover />
          <AccountPopover />
        </Stack>
      </StyledToolbar>
    </StyledRoot>
  );
}
